import { render, staticRenderFns } from "./CompanyCalculationList.vue?vue&type=template&id=374e1096&scoped=true&"
import script from "./CompanyCalculationList.vue?vue&type=script&lang=js&"
export * from "./CompanyCalculationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374e1096",
  null
  
)

export default component.exports